import Tooltip from './Tooltip';

export default Tooltip;



// WEBPACK FOOTER //
// ./ext/tooltip/src/index.js